import React from 'react';
import Navigation from '../components/Navigation';
import MegaPokemon from '../components/MegaPokemon';
import Logo from '../components/Logo';
import Footer from '../components/Footer';
const Gmax = () => {
    return (
        <div>
            <Logo/>
            <Navigation />
            <MegaPokemon />
            <Footer />
        </div>
    );
};

export default Gmax;